"use client";
import { classes } from "@/classnames";
import classNames from "classnames";
import { useState } from "react";
import { FormItem } from "../form-item";
import { IInput } from "./input.types";

export const Input: IInput = ({
  label,
  required,
  className,
  error,
  ...rest
}) => {
  const [focused, setFocus] = useState(false);

  return (
    <FormItem
      label={label}
      required={required}
      className={classNames(classes.FormItem, className)}
      error={error}
      focused={focused}
    >
      <input
        {...rest}
        onFocus={() => setFocus(true)}
        onBlur={(e) => !e.currentTarget.value && setFocus(false)}
        className="w-full border-0 relative z-1 top-[10px] outline-0 text-[18px] font-[800] tracking-normal"
      />
    </FormItem>
  );
};
